export const hi: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'डैशबोर्ड (Dashboard)',
  'nav.focus': 'दैनिक लक्ष्य और रोडमैप (Daily Focus)',
  'nav.ai_assistant': 'स्वचालित परिचालन इंजन (Operational Engine)',
  'nav.calendar': 'गूगल कैलेंडर (Google Calendar)',
  'nav.book': 'क्लाइंट बुकिंग पेज (Public Booking)',
  'nav.bookings': 'बुकिंग और राजस्व (Bookings)',
  'nav.invoices': 'चालान / बिल (Invoices)',
  'nav.expenses': 'व्यावसायिक खर्च (Expenses)',
  'nav.settings': 'व्यापार और टैक्स मुख्यालय (Business HQ)',
  'nav.billing': 'सदस्यता और योजनाएं (Subscription)',
  'nav.j_lens': 'जे-लेंस वॉल्ट (J-Lens Vault)',
  'nav.concept': 'सिद्धांत और मानसिकता (Concept)',
  'nav.what_is': 'AzuraOS क्या है?',
  'nav.export': 'निर्यात और बैकअप (Export)',
  'nav.menu': 'मेनू (Menu)',
  'nav.welcome': 'स्वागत और बीवाईओके हब (BYOK Hub)',
  'nav.app_stack_modules': 'ऐप स्टैक मॉड्यूल',
  'nav.core_engines': '8 मुख्य इंजन',
  'nav.manifesto': 'संस्थापक प्रणाली और घोषणापत्र',
  'nav.workspace_actions': 'कार्यक्षेत्र क्रियाएँ (Workspace Actions)',
  'nav.export_records': 'रिकॉर्ड निर्यात करें',
  'nav.load_demo': 'डेमो सैंडबॉक्स लोड करें',
  'nav.partnerships': 'साझेदारी और समर्थन',
  'nav.request_partnership': 'साझेदारी पहुंच का अनुरोध करें',
  'nav.partner_subtext': 'बैंक एकीकरण, ईएसडी दल और प्रायोजन',
  'nav.interface_language': 'इंटरफ़ेस भाषा (Language)',
  'nav.legal_trust': 'कानूनी और विश्वास',
  'nav.security': 'सुरक्षा (Security)',
  'nav.faqs': 'अक्सर पूछे जाने वाले प्रश्न (FAQs)',
  'nav.terms': 'शर्तें (Terms)',
  'nav.privacy': 'गोपनीयता (Privacy)',
  'nav.refund': 'रिफंड नीति (Refund Policy)',
  'nav.contact': 'संपर्क करें (Contact)',
  'nav.report_bug': 'बग रिपोर्ट करें',
  'nav.invite_founder': '+ संस्थापक को आमंत्रित करें',
  'nav.privacy_active': 'सार्वजनिक गोपनीयता मोड: सक्रिय',
  'nav.privacy_off': 'सार्वजनिक गोपनीयता मोड: बंद',
  'nav.masked': 'छिपा हुआ (Masked)',
  'nav.visible': 'दृश्यमान (Visible)',
  'nav.live_margin': 'लाइव परिचालन मार्जिन (Live Margin)',
  'nav.target_safe_zone': 'सुरक्षित क्षेत्र लक्ष्य:',
  'nav.close_menu': 'मेनू बंद करें',
  'nav.founder_access': 'साइन इन करें / संस्थापक पहुंच',
  'nav.private_vault': 'निजी वॉल्ट कनेक्टेड',
  'nav.master_access': 'मास्टर संस्थापक पहुंच',
  'nav.lifetime': 'आजीवन (Lifetime)',
  'nav.pro_active': 'सॉवरेन प्रो सक्रिय (Pro Active)',
  'nav.trial_days': '7-दिवसीय परीक्षण: {days} दिन शेष',
  'nav.trial_expired': 'परीक्षण समाप्त (Trial Expired)',
  'nav.manage': 'प्रबंधित करें →',
  'nav.upgrade': 'अपग्रेड करें →',
  'nav.unlock_pro': 'प्रो अनलॉक करें →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'शुभ प्रभात (Good morning)',
  'dash.greeting_afternoon': 'शुभ दोपहर (Good afternoon)',
  'dash.greeting_evening': 'शुभ संध्या (Good evening)',
  'dash.value_prop': 'एक ही स्थान पर बहु-स्रोत नियंत्रण: वास्तविक समय में अपने शुद्ध लाभ मार्जिन को लाइव देखने के लिए 1 आय स्रोत और 1 खर्च दर्ज करें।',
  'dash.manage_streams': 'आय स्रोत प्रबंधित करें',
  'dash.close_streams': 'प्रबंधन बंद करें',
  'dash.income': 'कुल आय (Income)',
  'dash.collected': 'प्राप्त हुआ (Collected)',
  'dash.unpaid': 'बकाया (Unpaid)',
  'dash.expenses': 'व्यावसायिक खर्च (Expenses)',
  'dash.across_records': 'कुल रिकॉर्ड्स',
  'dash.net_profit': 'शुद्ध लाभ (Net Profit)',
  'dash.daily_focus_title': 'दैनिक ध्यान और राजस्व कार्य योजना',
  'dash.daily_focus_sub': 'लाभ और विकास को गति देने वाले उच्च-मूल्य संस्थापक कार्य',
  'dash.open_focus': 'फोकस रोडमैप खोलें',
  'dash.stream_profitability': 'स्रोत लाभप्रदता (Stream Profitability)',
  'dash.stream_sub': '1 सेवा या एकाधिक राजस्व धाराएँ • लाइव मार्जिन ट्रैकिंग',
  'dash.quick_actions': 'त्वरित कार्य (Quick Actions)',
  'dash.add_booking': 'बुकिंग जोड़ें',
  'dash.add_booking_desc': 'एक नया ग्राहक राजस्व स्रोत दर्ज करें',
  'dash.add_expense': 'खर्च दर्ज करें',
  'dash.add_expense_desc': 'व्यापार/परिचालन लागत दर्ज करें',
  'dash.add_insight': 'इनसाइट जोड़ें',
  'dash.add_insight_desc': 'एक नया जे-लेंस नियम रिकॉर्ड करें',
  'dash.quick_add_title': 'त्वरित प्रविष्टि (Quick Add)',
  'dash.quick_revenue': '+ त्वरित राजस्व (बुकिंग)',
  'dash.quick_expense': '+ त्वरित खर्च (बहीखाता)',
  'dash.recent_activity': 'हाल की गतिविधि (Recent Activity)',
  'dash.no_activity': 'अभी तक कोई हालिया गतिविधि दर्ज नहीं की गई है। शुरू करने के लिए त्वरित कार्यों का उपयोग करें।',
  'dash.spotlight_insight': 'स्पॉटलाइट जे-लेंस इनसाइट',
  'dash.access_vault': 'वॉल्ट खोलें →',
  'dash.sandbox_active': 'सैंडबॉक्स सक्रिय (Sandbox Active)',
  'dash.load_demo_data': 'डेमो डेटा लोड करें',
  'dash.clear_sandbox': 'सैंडबॉक्स खाली करें',
  'dash.clear_confirm': 'डेटा मिटाएं?',
  'dash.yes_clear': 'हाँ, मिटाएं',
  'dash.cancel': 'रद्द करें',

  // Bookings View
  'bookings.title': '📅 बुकिंग और राजस्व स्रोत (Bookings)',
  'bookings.subtitle': 'सॉवरेन ग्राहक आय चैनल और सेवाएं',
  'bookings.public_page': 'सार्वजनिक बुकिंग पेज',
  'bookings.import_csv': 'सीएसवी आयात करें (CSV)',
  'bookings.add_button': 'नई बुकिंग जोड़ें',
  'bookings.client_link_title': 'ग्राहक शेड्यूलिंग लिंक (Client Link)',
  'bookings.client_link_desc': 'स्वचालित बुकिंग और गूगल कैलेंडर सिंक के लिए ग्राहकों के साथ मानक या कस्टम-मूल्य शेड्यूलिंग लिंक साझा करें।',
  'bookings.link_active': 'सक्रिय (Active)',
  'bookings.generate_custom_link': '⚡ कस्टम मूल्य लिंक बनाएं',
  'bookings.hide_custom_link': 'कस्टम लिंक छिपाएं',
  'bookings.copy_standard_link': 'मानक लिंक कॉपी करें',
  'bookings.copied_link': 'लिंक कॉपी हो गया!',
  'bookings.preview': 'पूर्वावलोकन (Preview)',
  'bookings.search_placeholder': 'ग्राहक या सेवा द्वारा खोजें...',
  'bookings.filter_all': 'सभी स्रोत (All Streams)',
  'bookings.table_client': 'ग्राहक का नाम',
  'bookings.table_stream': 'सेवा / स्रोत',
  'bookings.table_date': 'तारीख',
  'bookings.table_amount': 'राशि',
  'bookings.table_status': 'स्थिति (Status)',
  'bookings.table_actions': 'क्रियाएं',
  'bookings.mark_paid': 'भुगतान हुआ चिह्नित करें',
  'bookings.mark_unpaid': 'बकाया चिह्नित करें',
  'bookings.delete': 'हटाएं',
  'bookings.no_records': 'कोई ग्राहक बुकिंग नहीं मिली। शुरू करने के लिए ऊपर दिए गए "नई बुकिंग जोड़ें" का उपयोग करें।',

  // Invoices View
  'invoices.title': '📄 ग्राहक चालान और प्राप्य (Invoices)',
  'invoices.subtitle': 'व्यावसायिक चालान निर्माण और भुगतान समाधान',
  'invoices.create_invoice': 'नया चालान बनाएं',
  'invoices.tab_all': 'सभी चालान',
  'invoices.tab_paid': 'भुगतान किए गए',
  'invoices.tab_outstanding': 'बकाया / लंबित',
  'invoices.tab_overdue': 'अतिदेय (Overdue)',
  'invoices.table_number': 'चालान सं.',
  'invoices.table_client': 'ग्राहक',
  'invoices.table_issue_date': 'जारी करने की तारीख',
  'invoices.table_due_date': 'अंतिम तारीख',
  'invoices.table_total': 'कुल राशि',
  'invoices.table_status': 'स्थिति',
  'invoices.download_pdf': 'पीडीएफ डाउनलोड करें',
  'invoices.mark_as_paid': 'भुगतान हुआ',
  'invoices.no_records': 'अभी तक कोई चालान नहीं बनाया गया है। नया चालान बनाने के लिए ऊपर क्लिक करें।',

  // Expenses View
  'expenses.title': '💳 व्यावसायिक खर्च और बहीखाता (Expenses)',
  'expenses.subtitle': 'सॉवरेन खर्च ट्रैकिंग और टैक्स छूट अनुकूलन',
  'expenses.log_expense': 'खर्च दर्ज करें',
  'expenses.import_csv': 'सीएसवी आयात करें',
  'expenses.total_outflow': 'कुल व्यावसायिक खर्च',
  'expenses.tax_deductible': 'टैक्स कटौती योग्य',
  'expenses.search_placeholder': 'विक्रेता या विवरण द्वारा खोजें...',
  'expenses.filter_all': 'सभी श्रेणियां',
  'expenses.table_category': 'श्रेणी (Category)',
  'expenses.table_description': 'विवरण / विक्रेता',
  'expenses.table_date': 'तारीख',
  'expenses.table_claimable': 'टैक्स दावा योग्य',
  'expenses.table_amount': 'राशि',
  'expenses.table_actions': 'क्रियाएं',
  'expenses.claimable_yes': 'हाँ (कटौती योग्य)',
  'expenses.claimable_no': 'नहीं (व्यक्तिगत)',
  'expenses.no_records': 'अभी तक कोई खर्च दर्ज नहीं किया गया है। वास्तविक शुद्ध मार्जिन देखने के लिए व्यावसायिक खर्च जोड़ें।',

  // Daily Focus & Roadmap
  'focus.title': '🎯 दैनिक फोकस और कार्य योजना (Daily Focus)',
  'focus.subtitle': 'लाभ और ग्राहक प्रवाह को गति देने वाले उच्च-मूल्य संस्थापक कार्य',
  'focus.add_task': 'राजस्व कार्य जोड़ें',
  'focus.active_tasks': 'सक्रिय प्राथमिकता कार्य',
  'focus.completed_tasks': 'पूर्ण कार्य',
  'focus.high_leverage': 'उच्च प्राथमिकता',
  'focus.mark_done': 'पूर्ण चिह्नित करें',
  'focus.delete_task': 'हटाएं',
  'focus.no_tasks': 'सभी कार्य पूर्ण हैं! गति बनाए रखने के लिए नया कार्य जोड़ें।',

  // Automated Operational Engine
  'ai.title': '⚡ स्वचालित परिचालन इंजन (Operational Engine)',
  'ai.subtitle': 'क्लाइंट-साइड एन्क्रिप्टेड गणना और रणनीतिक व्यावसायिक बुद्धिमत्ता (शून्य डेटा प्रतिधारण)',
  'ai.ask_placeholder': 'नकदी प्रवाह, मार्जिन अनुकूलन, या मूल्य निर्धारण रणनीति के बारे में पूछें...',
  'ai.send': 'विश्लेषण करें',
  'ai.thinking': 'परिचालन इंजन आपकी वित्तीय गणनाओं का विश्लेषण कर रहा है...',
  'ai.prompt_margin': 'मैं अपने शुद्ध लाभ मार्जिन को 60% तक कैसे बढ़ा सकता हूँ?',
  'ai.prompt_tax': 'टैक्स बफर को अनुकूलित करने के लिए मुझे किन खर्चों का दावा करना चाहिए?',
  'ai.prompt_pricing': 'मुझे अपनी सेवाओं के पैकेज की कीमत कैसे तय करनी चाहिए?',
  'ai.clear_chat': 'इतिहास साफ़ करें',

  // Business & Tax HQ
  'hq.title': '🏢 व्यापार और टैक्स मुख्यालय (Business HQ)',
  'hq.subtitle': 'प्रोफ़ाइल, मुद्रा, जीएसटी/वैट टैक्स नियम, क्षेत्राधिकार प्रीसेट और सीए ऑडिट निर्यात',
  'hq.tab_profile': 'प्रोफ़ाइल और पहचान',
  'hq.tab_currency_tax': 'मुद्रा और टैक्स नियम',
  'hq.tab_accountant_view': 'लेखाकार और सीए ऑडिट व्यू',
  'hq.tab_exports': 'डेटा निर्यात और बैकअप',
  'hq.tab_security': 'सुरक्षा सुरक्षा उपाय',
  'hq.jurisdiction_preset_title': 'क्षेत्रीय अधिकार क्षेत्र प्रीसेट (Regional Preset)',
  'hq.jurisdiction_preset_desc': 'स्थानीय मुद्रा, जीएसटी/वैट टैक्स नियमों और आधिकारिक टैक्स अधिकारियों को स्वचालित रूप से कॉन्फ़िगर करने के लिए अपना देश चुनें।',
  'hq.accountant_view_title': 'लेखाकार और सीए ऑडिट व्यू (Accountant View)',
  'hq.accountant_view_desc': 'बाहरी सीए (CA), एकाउंटेंट या बैंक ऋण मूल्यांकन के लिए मानकीकृत प्री-अकाउंटिंग सारांश और ऑडिट पैक।',
  'hq.export_pdf_audit': 'प्रिंट करने योग्य सीए ऑडिट स्टेटमेंट (PDF)',
  'hq.export_csv_audit': 'सीए ऑडिट सीएसवी निर्यात (CSV)',
  'hq.currency_symbol': 'मुद्रा चिह्न (Symbol)',
  'hq.currency_code': 'मुद्रा कोड (Code)',
  'hq.vat_rate': 'जीएसटी / वैट दर (%)',
  'hq.tax_authority': 'टैक्स प्राधिकरण का नाम',
  'hq.save_settings': 'व्यापार सेटिंग्स सहेजें',

  // Financial & Metric Labels
  'metric.gross_revenue': 'कुल आय (Gross Revenue)',
  'metric.total_expenses': 'कुल खर्च (Total Expenses)',
  'metric.net_profit': 'शुद्ध परिचालन आय (Net Profit)',
  'metric.profit_margin': 'लाभ मार्जिन (Profit Margin)',
  'metric.active_bookings': 'सक्रिय बुकिंग (Active Bookings)',
  'metric.paid_invoices': 'भुगतान किए गए बिल (Paid Invoices)',
  'metric.unpaid_invoices': 'बकाया बिल (Unpaid Invoices)',
  'metric.tax_buffer': 'अनुमानित टैक्स बफर (Tax Buffer)',
  'metric.currency': 'परिचालन मुद्रा (Currency)',
  'metric.tax_rate': 'जीएसटी / टैक्स दर (Tax Rate)',

  // Actions & Common Buttons
  'btn.save': 'परिवर्तन सहेजें (Save)',
  'btn.cancel': 'रद्द करें (Cancel)',
  'btn.download': 'डाउनलोड करें (Download)',
  'btn.export_pdf': 'पीडीएफ रिपोर्ट डाउनलोड करें',
  'btn.export_csv': 'सीएसवी निर्यात करें (CSV)',
  'btn.cpa_pack': 'अकाउंटेंट पैक निर्यात करें (CPA Pack)',
  'btn.new_booking': 'नई बुकिंग जोड़ें',
  'btn.new_expense': 'नया खर्च दर्ज करें',
  'btn.add_task': 'नया कार्य जोड़ें',
  'btn.sync_calendar': 'गूगल कैलेंडर सिंक करें',
  'btn.privacy_mode': 'गोपनीयता मोड (Privacy Mode)',
  'btn.manage_subscription': 'सदस्यता प्रबंधित करें',
  'btn.sign_in': 'साइन इन करें (Sign In)',
  'btn.sign_out': 'साइन आउट (Sign Out)',
  'btn.delete': 'हटाएं (Delete)',
  'btn.edit': 'संपादित करें (Edit)',
  'btn.close': 'बंद करें (Close)',

  // Statuses
  'status.paid': 'भुगतान हुआ (Paid)',
  'status.unpaid': 'बकाया (Unpaid)',
  'status.overdue': 'अतिदेय (Overdue)',
  'status.safe': 'स्वस्थ मार्जिन (Healthy)',
  'status.warning': 'मार्जिन चेतावनी (Warning)',
  'status.trial_active': 'नि:शुल्क परीक्षण सक्रिय (Trial)',
  'status.pro_active': 'सॉवरेन प्रो (Pro Active)',
};
